<template>
  <el-container class="layout__wrap">
    <el-header class="header__wrap shadow" height="60px">
      <div class="logo__wrap">
        <div class="logoBg">
          <img class="logo" :src="require(`@/assets/img/${subject_id == 11 ?'blyxlogow.png':'logo20250613name.png'}`)" alt="">
        </div>
        <!-- <span class="logo_txt">{{companyName}}</span> -->
        <div class="J_menutoggle" @click="toggleColl">
          <el-tooltip
            effect="dark"
            :content="isCollapse ? `展开` : `收起`"
            placement="bottom"
          >
            <i class="el-icon-menu" color="#fff"></i>
          </el-tooltip>
        </div>
      </div>
      <div class="avatar__wrap">
        <el-dropdown style="margin-right:10px" @command="handleCommand">
          <span class="el-dropdown-link" style="color:#fff;font-size:16px">
          {{subject_name}}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item  v-for="item in subjectList" :disabled="item.subject_id == selectedSubjectId" :command="item.subject_id" :key="item.subject_id">
              {{item.subject_name}}
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-button round size="mini" icon="el-icon-s-help" style="margin-right:10px;color: #2cb167;" @click="handleHelp">帮助指导</el-button>
        <div class="title" style="display:flex;align-items: center;">
          <img style="width:24px;margin-right:10px;" src="@/assets/img/default@2x.png" alt="">
          <div> {{userName}}</div>
        </div>
        <el-popover
          placement="bottom"
          width="400"
          trigger="click"
          :append-to-body='false'>
          <template v-if="total > 0">
            <div class="is_rade" v-if="no_read_count > 0" @click="handleMessAll">全部已读</div>
            <div class="messageWrap" >
              <div v-for="(item,index) in messageList" :key="index" class="list" @click="handleMessage(item)">
                <div style="display: flex;align-items: center;">
                  <span :class="item.is_read == 0 ? 'dot' : 'dot2'">&nbsp;</span>
                  <span class="name">{{item.title}}</span>
                </div>
                <div class="time">{{item.create_time}}</div>
              </div>
            </div>
          </template>
          <template v-else>
            <el-empty :image-size="100" description="暂无通知"></el-empty>
          </template>
          <el-badge slot="reference" :value="no_read_count" :hidden="no_read_count == 0 ? true : false" :max="99" class="item" style="margin-left:40px;margin-right:16px;">
            <img style="width:24px;" src="@/assets/img/notion@2x.png" alt="">
          </el-badge>
        </el-popover>
        <el-tooltip class="item" effect="dark" content="退出登录" placement="bottom">
          <div class="logout" @click="logout" >
            <img style="width:24px;" src="@/assets/img/exit@2x.png" alt="">
          </div>
        </el-tooltip>
      </div>
    </el-header>
    <el-container style="overflow-y:scroll;">
      <NaviBar :isCollapse="isCollapse"></NaviBar>
      <!-- v-waterMarker="{ text: '江西金手指版权所有', textColor: 'rgba(180, 180, 180, 0.6)' }" -->
      <el-main class="layout__main" v-waterMarker="{ text: userName+' '+account,font:'18px Microsoft YaHei', textColor: 'rgba(204, 204, 204, 1)' }">
        <page-header></page-header>
        <router-view></router-view>
      </el-main>
    </el-container>

    <!-- 查看系统通知 -->
    <div class="messDialog">
      <el-dialog
        :title="currTitle"
        :visible.sync="dialogVisibleMessage"
        width="600px"
        :before-close="handleClose">
        <div v-html="currContent" style="min-height:100px;"></div>
        <!-- <div style="text-align: right;font-size: 14px;margin-top:20px;">{{currTime}}</div> -->
      </el-dialog>
    </div>

    <!-- 系统通知未读弹窗群，最多10个 -->
    <template v-if="noMessageList.length > 0 ">
      <el-dialog
        v-for="(dialog, index) in noMessageList"
        top="2vh"
        :key="index"
        title=""
        :visible.sync="dialog.visible"
        :close-on-click-modal="false"
        :show-close="false"
        width="600px"
        center
        :class="'dialog'+index">
        <div style="text-align: center;font-size: 16px;font-weight: bold;margin-bottom:20px;">{{dialog.title}}</div>
        <div v-html="dialog.content" class="dialog-content"></div>
        <div style="text-align: right;font-size: 14px;margin-top:20px;">{{dialog.create_time}}</div>
        <span slot="footer" class="dialog-footer">
          <el-button type="warining" plain @click="handleCloseAll">全部关闭</el-button>
          <el-button type="primary" @click="handleCloseOnce(dialog,index)">知道了</el-button>
        </span>
      </el-dialog>
    </template>

  </el-container>
</template>
<script>
import PageHeader from './PageHeader.vue';
import NaviBar from './NaviBar';
import { setStorage, getStorage, clear } from "@/storage"
export default {
  name: 'LayoutContainer',
  components: {
    NaviBar,
    PageHeader
  },
  data() {
    return {
      isCollapse: false,
      toggleMenu: false,
      userName: getStorage('userName'),
      account: getStorage('account').toString().slice(-4),
      companyName: getStorage('companyName'),
      subject_name: getStorage('subject_name'),
      subject_id: getStorage('subject_id'), // 当前选中的主体ID
      subjectList: getStorage('subject_list'), // 主体列表
      selectedSubjectId: getStorage('userId'), // 当前选中的主体ID
      messageList: [],
      dialogVisibleMessage: false,
      no_read_count: 0, // 新消息数量
      total: 0, // 消息总数
      currTitle: '',
      currContent: '',
      currTime: '',
      dialogVisible: true,
      noMessageList: [],
      is_showDialog: getStorage('is_showDialog'), 
      time: null,
    }
  },
  created() {
    this.getMessage();
    this.$store.commit('set_is_sys', getStorage('is_sys'))
  },
  mounted() {
    this.getGoodsType();
    this.getMerchant();
    this.getArea();

    this.$nextTick(() => {
      // 10分钟刷一次未读的新通知接口
      this.time = setInterval(() => {
        this.getNoMessage();
      },600000)
    })
  },
  beforeDestroy () {
    this.time = null;
  },
  methods: {
    logout() {
      this.$confirm("请确认是否退出登录？", "提示", {
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            const device_no = getStorage('device_no');
            clear(); // 删除token
            setStorage('device_no',device_no);
            window.location.reload();
            done()
          } else {
            done()
          }
        }
      })
    },
    toggleColl() {
      this.isCollapse = !this.isCollapse;
      this.toggleMenu = !this.toggleMenu;
    },
    handleClose() {
      this.dialogVisibleMessage = false;
      this.is_showDialog = false;
      this.getMessage();
    },
    // 获取10分钟之内的(未读}通知列表
    getNoMessage() {
      this.$http.get('/admin/message/list',{params: {page:1,count:100,is_time:1,is_read:1}}).then(res => {
        if(res.code == 1) {
          this.no_read_count = res.data.no_read_count;
          let arr = res.data.list;
          this.noMessageList = arr.map(v => {
            return {
              ...v,
              visible: true,
            }
          }).slice(0,10).reverse(); // 最多取前10项
          console.log(this.noMessageList,"******")
        }
      })
    },
    // 获取通知列表
    getMessage() {
      this.$http.get('/admin/message/list',{params: {page:1,count:10000}}).then(res => {
        if(res.code == 1) {
          this.messageList = res.data.list;
          this.total = res.data.total;
          this.no_read_count = res.data.no_read_count;
          let arr = res.data.list.filter(item => item.is_read == 0)
          if(this.is_showDialog == true) {
            this.noMessageList = arr.map(v => {
              return {
                ...v,
                visible: true,
              }
            }).slice(0,10).reverse(); // 最多取前10项
          } else {
            this.noMessageList = []
          }
        }
      })
    },
    // 查看通知
    handleMessage(row) {
      this.dialogVisibleMessage = true;
      this.$http.get('/admin/message/info',{params: {id:row.id}}).then(res => {
        if(res.code == 1) {
          this.currTitle = res.data.title;
          this.currContent = res.data.content;
          this.currTime = res.data.create_time;
        }
      })
    },
    // 单条已读
    handleCloseOnce(row,index) {
      this.$http.get('/admin/message/info',{params: {id:row.id}}).then(res => {
        if(res.code == 1) {
          this.noMessageList[index].visible = false;
          this.no_read_count--
          // this.getMessage()
        }
      })
    },
    // 全部已读
    handleMessAll() {
      this.$confirm('请确认全部已读操作？','提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(() => {
        this.$http.post('/admin/message/all',{}).then(res => {
          if(res.code == 1) {
            this.dialogVisibleMessage = false;
            this.$message.success("操作成功！")
            this.getMessage();
          }
        })
      }).catch(() => {})
    },
    // 全部关闭
    handleCloseAll() {
      setStorage('is_showDialog', false);
      let arr = this.noMessageList.map(item => ({ ...item, visible: false }));
      this.noMessageList = arr
      console.log(this.noMessageList,"arr")
      // 刷新通知列表
      this.$http.get('/admin/message/list',{params: {page:1,count:10000}}).then(res => {
        if(res.code == 1) {
          this.messageList = res.data.list;
          this.total = res.data.total;
          this.no_read_count = res.data.no_read_count;
          this.noMessageList = [];
        }
      })
    },
    // 获取所有商品分类
    getGoodsType() {
      this.$http.post('/admin/cate/all',{}).then(res => {
        if(res.code == 1) {
          this.$store.commit('setGoodsType', res.data)
        }
      })
    },
    // 获取客户
    getMerchant() {
      this.$http.post('/admin/admin/merchantList',{page:1,count: 1000}).then(res => {
        if(res.code == 1) {
          this.$store.commit('setMerchant', res.data.list)
        }
      })
    },
    // 获取全国省市
    getArea() {
      this.$http.post('/common/district/all', {is_all:1}).then(res => {
        if(res.code === 1) {
          this.areaArr = res.data.list;
          for (const key in this.areaArr) {
            // 删除第三层children属性
            for (const i in this.areaArr[key].children) {
              delete this.areaArr[key].children[i].children
            }
          }
          this.$store.commit('setArea', this.areaArr)
        }
      })
    },
    handleHelp() {
      window.open(this.$router.resolve({name: 'NoviceIndex'}).href, '_blank');
      // window.open(this.$router.resolve({name: 'GoodsType'}).href, '_blank');
    },
    // 处理主体切换
    async handleCommand(subjectId) {
      const selectedSubject = this.subjectList.find(item => item.subject_id == subjectId);
      if (!selectedSubject) {
        this.$message.error('未找到选中的主体信息');
        return;
      }
      try {
        // 发送切换主体请求
        const res = await this.$http.post('/admin/admin/change', { 
          subject_id: subjectId,
          password: getStorage('password') 
        });
        if(res.code == 1) {
          setStorage('accountId', res.data.admin_id);
          // 切换成功，更新本地数据
          this.selectedSubjectId = subjectId;
          this.subject_name = selectedSubject.subject_name;
          this.subject_id = selectedSubject.subject_id;
          // 更新本地存储
          setStorage('userId', subjectId);
          setStorage('subject_id', subjectId);
          setStorage('subject_name', selectedSubject.subject_name);
          setStorage('userName', selectedSubject.name);
          this.$message.success(`已切换到主体：${selectedSubject.subject_name}`);
          const assRes = await this.$http.get('/admin/admin/getAccess',{params:{}});
          if(assRes.code == 1) {
            setStorage('access_list', assRes.data.access_list); // 该账号的权限菜单列表
            setStorage('is_sys', assRes.data.is_sys); //是否是系统创建 1:是（超级管理员） 0:否
            setStorage('city', assRes.data.city)
            setTimeout(() => {window.location.reload()}, 200)
          }
          // 重新加载相关数据
          this.getMessage(); // 重新获取消息
          this.getMerchant(); // 重新获取商户信息
        } else {
          // 切换失败，恢复原来的选择
          this.selectedSubjectId = getStorage('subject_id');
          this.$message.error(res.msg || '切换主体失败');
        }
      } catch (error) {
        console.error('切换主体请求失败:', error);
        // 请求失败，恢复原来的选择
        this.selectedSubjectId = getStorage('subject_id');
      }
    }
  }
}
</script>

<style scoped lang="scss">
.layout__wrap {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  
  .header__wrap {
    padding: 0 !important;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: $theme !important;
    border-bottom: solid 1px #eee;
    // background-image: linear-gradient(to right, $theme, #0bCFFF);
    .logo__wrap {
      display: flex;
      align-items: center;
      .logo {
        display: block;
        width:180px;
        // height: 32px;
      }
      .logo_txt {
        color: #5a5a5a;
        font-weight: bold;
        margin-left: 40px;
      }
      .J_menutoggle {
        color: #fff;
        margin-left: 20px;
      }
    }
    .avatar__wrap {
      display: flex;
      align-items: center;
      color: #fff;
      font-size: 14px;
      cursor: pointer;

      .title {
        // width: 100%;
        text-align: center;
      }
      .logout {
        // width: 130px;
        margin-right: 40px;
        margin-left: 15px;
      }
      
      ::v-deep .el-popover {
        min-width: 80px;
      }
    }
  }
  .layout__main {
    display: flex;
    flex-direction: column;
    padding: 0;
    background-color: #EEF6FD;
    position: relative;
    overflow: hidden;

    .page-header__wrap {
      display: flex;
      justify-content: space-between;
      align-items: center;
      background-color: #FFFFFF;
      color: #595959;
      border-bottom: solid 1px #F1F1F1;

      .title {
        height: 58px;
        line-height: 58px;
        
      }
    }

    &>div {
      flex: 1;
      min-height: 0;
      // overflow-y: scroll;
    }

  }
}
.logoBg {
  padding: 0 20px;
  // background: rgb(255, 255, 255);
  width: 210px;
  height: 60px;
  display: flex;
  align-items: center;
  border-bottom: solid 1px #eee;
}
.is_rade {
  color:#2cb167;
  cursor: pointer;
  padding:12px;
  border-bottom:solid 1px #eee;
  box-shadow: 0 0 8px 0 rgba(232, 237, 250, 0.6), 0 2px 4px 0 rgba(232, 237, 250, 0.5);
}
.messageWrap {
  max-height: 600px;
  overflow-y: scroll;
}
.messageWrap::-webkit-scrollbar {
  width:3px;
}
.messageWrap::-webkit-scrollbar-thumb {
  background: #8d8d8d;
  border-radius: 5px;
}
.messageWrap .list {
  padding: 10px;
  border-top: solid 1px #eee;
  cursor: pointer;
}
.messageWrap .list:first-child {
  border: none;
}
.messageWrap .list:hover .name {
  cursor: pointer;
  color: #2cb167;
  text-decoration: underline;
}
.messageWrap .list:hover .time {
  cursor: pointer;
  color: #2cb167;
}
.messageWrap .name {
  font-size: 15px;
  font-weight: bold;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 360px;
}
.messageWrap .time {
  color: #666666;
  margin-top: 10px;
  margin-left: 20px;
}
.messageWrap .dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #f00808;
  display: inline-block;
  margin-right: 10px;
}
.messageWrap .dot2 {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #ccc;
  display: inline-block;
  margin-right: 10px;
}
.messDialog ::v-deep .el-dialog__header{
  background: #F5F5F5;
}
.messDialog ::v-deep .el-dialog__title {
  line-height: 24px;
  font-size: 18px;
  color: #303133;
  width: 520px;
  display: block;
  font-weight: bold;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.avatar__wrap ::v-deep .el-popover {
  padding: 0;
}
.content {
  min-height: 300px;
}
.dialog-content {
  // min-height:100px;
  height:400px;
  overflow-y:scroll;
}
.dialog-content::-webkit-scrollbar {
  width:3px;
}
.dialog-content::-webkit-scrollbar-thumb {
  background: #8d8d8d;
  border-radius: 5px;
}
.messItem {
  position:absolute;
  top:0;
  right:0;
  bottom:0;
  left:0;
}
.dialog1 {
  margin-top: 10px;
  margin-left: 20px;
}
.dialog2 {
  margin-top: 20px;
  margin-left: 30px;
}
.dialog3 {
  margin-top: 30px;
  margin-left: 40px;
}
.dialog4 {
  margin-top: 40px;
  margin-left: 50px;
}
.dialog5 {
  margin-top: 50px;
  margin-left: 60px;
}
.dialog6 {
  margin-top: 60px;
  margin-left: 70px;
}
.dialog7 {
  margin-top: 70px;
  margin-left: 80px;
}
.dialog8 {
  margin-top:80px;
  margin-left: 90px;
}
.dialog9 {
  margin-top:90px;
  margin-left: 100px;
}
.dialog10 {
  margin-top:10px;
  margin-left: 110px;
}
</style>
